// @flow

const initialState = {
  auth: {
    status: null,
    email: '',
    photoURL: '',
    firstName: '',
    lastName: '',
    uid: ''
  },

  homePage: {
    toggleTodos: false
  },

  habits: []
};

export default initialState;



// WEBPACK FOOTER //
// ./initialState.js